import React from 'react'
import { getSelectUserRoleMenus } from '../../api/common'
import withRouter from '../withRouter'
import md5 from 'js-md5'

export interface ScrollToTopProps {
    onUpdate?: (hashHistory, routerActionm, path, pathname) => void
}

// 不需要回到顶部的路由
const routersList = ['/materialManagement', '/materialManagement/cloudMaterial', '/strategyManagement', '/strategyManagement/cloudStrategy']

class ScrollToTop extends React.Component<ScrollToTopProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hashHistory: JSON.parse(window.localStorage.getItem('router') || '{}')?.hashHistory || [],
            routerAction: JSON.parse(window.localStorage.getItem('router') || '{}')?.routerAction || 'PUSH',
            path: JSON.parse(window.localStorage.getItem('router') || '{}')?.path || [],
            pathname: JSON.parse(window.localStorage.getItem('router') || '{}')?.pathname || window.location.pathname,
            oldpathname: JSON.parse(window.localStorage.getItem('router') || '{}')?.oldpathname || window.location.pathname,
            initpathname:JSON.parse(window.localStorage.getItem('router') || '{}')?.initpathname || '',
            loading:false
        }
    }
    async getSelectUserRoleMenus() {
        try {
            const res:any = await getSelectUserRoleMenus()
            const _permission = (res.data || []).map(item => md5(item))
            localStorage.setItem(md5('permission'), JSON.stringify(_permission))
            this.setState({
                loading:true
            })
        } catch (error) {
            this.setState({
                loading:true
            })
        }
    }
    componentDidUpdate(prevProps) {
        // 监听路由
        const pathname = `${window.location.pathname}-${this.props.location.pathname}-${this.props.location.search}`
        const _pathname = `${window.location.pathname}-${prevProps.location.pathname}-${prevProps.location.search}`
        if ( pathname !== _pathname) {
            const hashHistory = this.state.hashHistory
            let routerAction = this.state.routerAction
            const b = hashHistory.findIndex(item => item === pathname)
            const c = hashHistory.findIndex(item => item === _pathname)
            let newHashHistory = hashHistory
            if (b === -1) {
                let a = `${window.location.pathname}-${this.props.location.pathname}-`
                const index = newHashHistory.findIndex(item => item.includes(a))
                if( index > -1) {
                    // 路由中已经有了 只是携带？ 后面的参数不一致
                    newHashHistory[index] = pathname
                }else {
                    // 路由中没有当前路由 代表是前进 且添加当前路由
                    newHashHistory = [...hashHistory, pathname]
                }
                routerAction = 'PUSH'
            } else if (b === hashHistory.length - 1) {
                routerAction = 'PUSH'
                // 路由变化时回到顶部
                if( !routersList.includes(this.props.location.pathname) ) {
                    const time = setTimeout(() => {
                        window.scrollTo(0, 0)
                        clearTimeout(time)
                    }, 100)
                }
            }else if (b < c) {
                routerAction = 'POP'
            } else {
                routerAction = 'PUSH'
                if( !routersList.includes(this.props.location.pathname) ) {
                    const time = setTimeout(() => {
                        window.scrollTo(0, 0)
                        clearTimeout(time)
                    }, 100)
                }
            }
            this.setState({
                hashHistory: newHashHistory,
                routerAction,
                pathname: this.state.pathname
            })
            this.props.onUpdate && this.props.onUpdate(newHashHistory, routerAction, this.state.path, this.state.pathname)
            window.localStorage.setItem('router', JSON.stringify({
                hashHistory: newHashHistory,
                routerAction,
                path: this.state.path,
                pathname: this.state.pathname,
                oldpathname:this.state.oldpathname,
                initpathname:this.state.initpathname
            }))
        }
    }
    componentDidMount() {
        this.getSelectUserRoleMenus()
        const { hashHistory, routerAction, path, pathname, oldpathname, initpathname } = this.state
        const _pathname = `${window.location.pathname}-${this.props.location.pathname}-${this.props.location.search}`
        const o = hashHistory.find(item => item === _pathname)
        let _routerAction = routerAction
        let _path = path
        const b = path.findIndex(item => item === `${oldpathname}-${window.location.pathname}`)
        const c = path.findIndex(item => item === pathname)
        if ( b === -1 && initpathname !== window.location.pathname) {
            // 路由中没有当前路由 代表是前进 且添加当前路由
            _path = [...path, `${oldpathname}-${window.location.pathname}`]
            _routerAction = 'PUSH'
        } else if (b < c) {
            _routerAction = 'POP'
        } else if( initpathname && initpathname === window.location.pathname && oldpathname !== window.location.pathname ) {
            _routerAction = 'POP'
        }else {
            _routerAction = 'PUSH'
        }
        const router = {
            hashHistory: !!o ? hashHistory : [...hashHistory, _pathname],
            routerAction: _routerAction,
            path: _path,
            oldpathname:`${window.location.pathname}`,
            pathname: `${oldpathname}-${window.location.pathname}`,
            initpathname:initpathname || window.location.pathname
        }
        this.setState({
            ...router
        })
        window.localStorage.setItem('router', JSON.stringify(router))
        this.props.onUpdate && this.props.onUpdate(router.hashHistory, router.routerAction, router.path, router.pathname)
    }
    render() {
        const { loading } = this.state
        return (
            loading && this.props.children
        );
    }
}

export default withRouter(ScrollToTop);